import OAPLayout from "../components/OfficeAccountingPage/OAPLayout";

const OfficeAccountingPage = () => {
  return <OAPLayout />;
};

export default OfficeAccountingPage;
